export default function init_utils(IconsView, iconsViewCache) {

IconsView.prototype.findItem = function(id, type, data = null) {
        if (!data) data = this.data;
        for (const item of data) {
            if (!item) continue;
            const itemTypeStr = Array.isArray(item.type) ? item.type[0] : item.type;
            const targetTypeStr = Array.isArray(type) ? type[0] : type;
            if (item.id == id && itemTypeStr == targetTypeStr && !item.special) {
                return item;
            }
            if (item.childs && item.childs.length > 0) {
                const found = this.findItem(id, type, item.childs);
                if (found) return found;
            }
        }
        return null;
    };

IconsView.prototype.findItemById = function(id, data = null) {
        if (!data) data = this.data;
        for (const item of data) {
            if (!item) continue;
            if (item.id == id && !item.special) return item;
            if (item.childs && item.childs.length > 0) {
                const found = this.findItemById(id, item.childs);
                if (found) return found;
            }
        }
        return null;
    };


IconsView.prototype.getDateFields = function (type) {
        if (this.types && this.types[type] && this.types[type].date) {
            let dateConfig = this.types[type].date;
            if (typeof dateConfig === 'string') {
                return [dateConfig];
            } else if (Array.isArray(dateConfig)) {
                return dateConfig;
            }
        }
        return null;
    };


IconsView.prototype.submitDateChange = function (itemData, start, end) {
        const dateFields = this.getDateFields(itemData.type);

        const formatIsoLocal = (date) => {
            if (typeof date === 'string') return date;
            if (!date) return null;
            const pad = (n) => n < 10 ? '0' + n : n;
            return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + ' ' +
                   pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
        };

        if (dateFields) {
            const changes = {};
            changes[dateFields[0]] = start ? formatIsoLocal(start) : null;
            if (dateFields[1]) {
                changes[dateFields[1]] = end ? formatIsoLocal(end) : null;
            }
            this.submitChange(itemData, changes);
        }
    };




IconsView.prototype.findPath = function(id, type, data = null, path = []) {
        if (!data) data = this.data;
        for (const item of data) {
            // Vérifier si l'élément actuel correspond à l'ID et au type recherchés
            if (item.id === id && item.type === type) {
                // Retourner le chemin jusqu'à cet élément
                return [...path, { field: 'id', value: item.id, type: item.type }];
            }
            // Si l'élément actuel a des enfants, rechercher récursivement dans ses enfants
            if (item.childs && item.childs.length > 0) {
                const found = this.findPath(id, type, item.childs, [...path, { field: 'id', value: item.id, type: item.type }]);
                // Si on a trouvé le chemin dans les enfants, le retourner
                if (found) return found;
            }
        }
        // Si l'élément n'est pas trouvé, retourner null
        return null;
    };


IconsView.prototype.setPath = function (element, absolute) {
        if (this.request) this.request.abort();
        if (absolute) {
            this.path = element;
        } else {
            // Switch view
            this.dataNodeParent = element;
            this.findTemplate(element);

            // update path
            this.path = [];
            while (true) {
                if (element && (element.id || element.label)) {
                    var pathNode;
                    pathNode = this.genPathNode(element);
                    this.path.unshift(pathNode);
                    element = element.parent;
                } else {
                    break;
                }
            }
        }
        setCookie(this.cookieName, JSON.stringify(this.path), 30);
    };


IconsView.prototype.genPathNode = function (element) {
        let pathNode;
        if (element.id) {
            pathNode = { field: 'id', value: element.id, type: element.type };
        } else {
            pathNode = { field: 'label', value: element.label, type: element.type };
        }
        return pathNode;
    }


IconsView.prototype.setIconSize = function (size, container, keep) {
        const myself = this;

        // Calendar views don't need icon sizing
        if (this.view === 'calendar' || this.view === 'calendar-week' || this.view === 'calendar-day') {
            return false;
        }

        if (this.dataNodeParent) {
            if (!this.dataNodeParent.iconSize) this.dataNodeParent.iconSize = {};
            if (!size) size = this.dataNodeParent.iconSize[this.view];
        }

        if (keep == 1) this.fixedSize[this.templateName] = size;
        else if (keep == -1) this.fixedSize[this.templateName] = null;
        else if (this.fixedSize[this.templateName]) size = this.fixedSize[this.templateName];

        if (!this.fixedSize[this.templateName]) {
            this.fixedSize[this.templateName] = size = this.viewThumbsWidth;
        }

        if (!this.element.is(":visible")) {
            return false;
        }

        if (!container) container = this.element;

        let height = size;
        let width = size * this.viewThumbsProportions;

        const item = container.find('.iv__item').not('.iv__breadcrumb__item, .iv__tabs__btn');
        if (!item.length) return false;
        const itemImage = container.find('.iv__item__image').not('.iv__breadcrumb__item__image');
        const itemImageIco = container.find('.iv__item__image .ico').not('.iv__breadcrumb__item__image .ico');

        const scrollableOriginal = document.documentElement.scrollHeight > document.documentElement.clientHeight;
        const widthItemExtra = item.outerWidth() - item.width() + parseInt(item.css('marginRight').replace('px', ''));
        const widthViewport = Math.floor((this.element.find('.iv__tabs__pane > .iv__container:visible').length) ? this.element.find('.iv__tabs__pane > .iv__container:visible').width() : container.width()) - 1;
        let widthItemGoal = width * this.viewItemWidthRatio;
        if (widthItemGoal > this.viewItemWidthMax) widthItemGoal = this.viewItemWidthMax;
        if (widthItemGoal < this.viewItemWidthMin) widthItemGoal = this.viewItemWidthMin;
        const colsCountRaw = widthViewport / widthItemGoal;
        const colsCount = Math.floor(colsCountRaw);
        const widthFull = Math.floor((widthViewport / colsCount) - widthItemExtra);


        if (this.viewItemWidthRatio) {
            item.css('minWidth', widthFull + 'px');
            item.css('width', widthFull + 'px');
            if (this.viewItemWidthRatio == 1) {
                height = widthFull;
            }
            else {
                height = widthFull / this.viewItemWidthRatio;
            }
        }

        if (!myself.viewItemThumbsMode) {
            width = size;
            height = size;
        }

        itemImage.css('maxWidth', 100 + '%');
        itemImage.css('minWidth', width + 'px');
        itemImage.css('width', width + 'px');
        itemImage.css('height', height + 'px');

        item.removeClass('iv__item--size--' + item.data('size'));
        item.data('size', size);
        item.addClass('iv__item--size--' + item.data('size'));


        itemImageIco.removeClass((index, className) => (className.match(/(^|\s)ico--size--\S+/g) || []).join(' '));
        itemImageIco.data('size', size);
        itemImageIco.addClass('ico--size--' + item.data('size'));

        this.dataNodeParent.iconSize[this.view] = size;
        const scrollableNew = document.documentElement.scrollHeight > document.documentElement.clientHeight;

        if (scrollableOriginal != scrollableNew) {
            this.setIconSize(size, container, keep);
        }

        this.element.find('.iv__zoom').val(size);
    };


IconsView.prototype.findTemplate = function (dataNode) {
        const myself = this;
        let newTemplateName = this.templateName;
        this.template = null;
        if (dataNode.view) {
            this.template = dataNode.view;
            newTemplateName = 'bundled';
        } else if (dataNode.template && this.data && this.templates && this.templates[dataNode.template]) {
            this.template = this.templates[dataNode.template];
            newTemplateName = dataNode.template;
        } else if (this.data && this.templates && this.templates[this.options.template]) {
            this.template = this.templates[this.options.template];
            newTemplateName = this.options.template;
        }
        if (!this.template && this.templates) {
            newTemplateName = (this.options.template) ? this.options.template : Object.keys(this.templates)[0];
            if (typeof newTemplateName === 'object') newTemplateName = newTemplateName[0];
            this.template = this.templates[newTemplateName];
        }

        // use data template overide
        if (dataNode.templateSet) {
            mergeToObject(dataNode.templateSet, this.template);
        }

        // update view
        if ((!this.view || newTemplateName != this.templateName) && !this.viewLock) {
            if (this.fixedView[newTemplateName]) this.view = this.fixedView[newTemplateName];
            else if (this.template && this.template.view && this.template.view.default) { this.view = this.template.view.default; } else { this.view = 'mosaic'; }
        }
        this.templateName = newTemplateName;

        // auto sort
        if (this.fixedSort[this.templateName]) {
            myself.sort(this.fixedSort[this.templateName][0], null, this.fixedSort[this.templateName][1]);
        }
        else if (this.template && this.template.view && this.template.view.sort) {
            myself.sort(this.template.view.sort, null, 'asc');
        }
    }


IconsView.prototype.loadPath = function (path, apply) {
        const myself = this;
        if (!path || typeof path !== 'object') {
            path = this.path;
        }

        // find to right place
        let dataNode = this.data;
        const pathValid = [];
        // loop in path node
        let node, data;
        for (const iPath in path) {
            node = path[iPath];
            if (!node) continue;

            let dataNodeDir = dataNode;
            if (dataNodeDir && dataNodeDir.childs) dataNodeDir = dataNodeDir.childs;
            // loop in data
            for (const iDataNode in dataNodeDir) {
                data = dataNodeDir[iDataNode];
                if (!data) continue;
                const dataDataType = Array.isArray(data.type) ? data.type[0] : data.type;
                const nodeType = Array.isArray(node.type) ? node.type[0] : node.type;

                if (data && data[node.field] == node.value && (!nodeType || dataDataType == nodeType) && !data.special) {
                    pathValid.push(node);
                    dataNode = data;
                    break;
                }
            }
        }

        if (apply) {
            this.pathValid = pathValid;
        }

        if (dataNode) {
            if (apply) {
                this.dataNode = dataNode.childs;
                this.dataNodeParent = dataNode;
                this.findTemplate(dataNode);
            } else {
                return dataNode;
            }
        }
    };


IconsView.prototype.applyQteClass = function (currentIcon) {
        const myself = this;
        var badgeVal = currentIcon.find('.iv__item__badge__input').val();
        currentIcon.removeClass(function(index, className) {
            return (className.match(/\biv__item--qte-\S+/g) || []).join(" ");
        });
        currentIcon.addClass('iv__item--qte-'+badgeVal);
        if (badgeVal == 0) {
            currentIcon.addClass('iv__item--qte-p0').addClass('inactive');
        }
        else {
            currentIcon.removeClass('inactive');
            currentIcon.addClass('iv__item--qte-p'+badgeVal.toString().length);
        }
    }


IconsView.prototype.remapData = function (data) {
        if (!data.special) {
            $.each(this.options.remap, (index, remapNodes) => {
                let current = data;
                $.each(remapNodes, (indexNode, remapNode) => {
                    current = current[remapNode];
                    if (current) {
                        switch(data[remapNode+'-type']) {
                            case 'imagePicker':
                                current = 'img-'+current;
                                break;
                        }
                    }
                })
                if (current) data[index] = current;
            })
        }
        return data;
    }


IconsView.prototype.findSelectionFromIcon = function (icon) {
        const data = icon.data('data');
        const { id } = data;
        const { type } = data;
        let result = false;
        $.each(this.selection, (key, selectionItem) => {
            if (selectionItem.id == id && selectionItem.type == type) {
                result = key;
            }
        });
        return result;
    }


IconsView.prototype.removeSelectionFromIcon = function (icon) {
        const selection = this.findSelectionFromIcon(icon);
        if (selection !== false) {
            this.selection = arrayRemove(this.selection, selection);
        }
    }


IconsView.prototype.addSelectionFromIcon = function (icon) {
        const selection = this.findSelectionFromIcon(icon);
        if (selection === false) {
            this.selection.push({
                id: icon.data('id'),
                type: icon.data('type'),
                data: icon.data('data'),
                el: icon,
            });
        }
    }


IconsView.prototype.changeSelection = function (lastSelected) {
        const myself = this;
        if (lastSelected) this.selectionLast = lastSelected;

        let grid = this.element;
        if (!$(grid).hasClass('iconGrid')) {
            grid = $(grid).closest('.iconGrid');
        }
        const selected = grid.find('.iv__item--selected');
        const buttonRestricted = grid.find('.iv__toolbar button.require-selection');
        if (selected.length > 0) {
            buttonRestricted.removeAttr('disabled');
        } else {
            buttonRestricted.attr('disabled', 'disabled');
        }

        // change selection value
        if (this.selectionInput) {
            let selectionValue = '';
            let selectionType = '';
            let selectionLabel = '';

            if (this.selection.length > 0) {
                for (let i = 0; i < this.selection.length; i++) {
                    selectionValue = (this.selection[i].id);
                    selectionType = (this.selection[i].type);
                    selectionLabel = ((this.selection[i].data) ? this.selection[i].data.label : '');
                }
            }

            this.selectionInput.val(selectionValue);
            this.selectionInputType.val(selectionType);
            this.selectionInputLabel.val(selectionLabel);

            this.element.val(selectionValue);
            this.element.data('type', selectionType);
            this.element.data('label', selectionLabel);

            this.selectionInput.change();
            this.selectionInputType.change();
            this.selectionInputLabel.change();
        }

        this.updatePreviewPane(lastSelected);

        if (myself.events.change) myself.events.change();
        myself.element.change();
    };


IconsView.prototype.preloadPreviewPane = function () {
        const myself = this;
        myself.preview.html('');
        let slider = $('<div class="iv__preview__slides slick"></div>');
        myself.preview.append(slider);
        let i = 0;
        $.each(myself.dataNode, function() {
            if (this.html) {
                let slide = '<div class="iv__preview__slide">'+this.html+'</div>';
                slider.append(slide);
                this.sliderIndex = i;
                i++;
            }
        })
    }


IconsView.prototype.updatePreviewPane = function (lastSelected) {
        const myself = this;
        const previewPane = this.element.find('.iv__preview:visible');
        if (previewPane && previewPane.find('.iv__preview__slide') && false) {

        }
        else if (previewPane) {
            lastSelected = $(lastSelected);
            previewPane.removeClass('iv__preview--loading');
            previewPane.removeClass('iv__preview--ajax');
            previewPane.removeClass('iv__preview--iframe');
            previewPane.removeClass('iv__preview--html');
            previewPane.removeClass('iv__preview--image');
            previewPane.removeClass('iv__preview--icon');
            previewPane.removeClass('iv__preview--msg');
            const data = lastSelected.data('data');
            myself.onUnload(previewPane);
            if (data) {
                if (data.url) {
                    if (this.template && this.template.view && this.template.view.preview.mode == 'ajax') {
                        previewPane.html('');
                        previewPane.addClass('iv__preview--loading');

                        ajaxForm({
                            url: data.url + '?output=text',
                            method: 'GET',
                            dataType: 'html',
                            callback(data, form) {
                                myself.onUnload(previewPane);
                                previewPane.html(data);
                                myself.onOnload(previewPane);
                                previewPane.addClass('iv__preview--ajax');
                                previewPane.removeClass('iv__preview--loading');
                            },
                        });
                    } else {
                        previewPane.html('<iframe src="' + data.url + '"></iframe>');
                        previewPane.addClass('iv__preview--iframe');
                    }
                } else if (data.html) {
                    previewPane.html(data.html);
                    previewPane.addClass('iv__preview--html');
                } else if (data.file) {
                    switch (fileExtention(data.file.toLowerCase())) {
                    case 'jpg':
                    case 'jpeg':
                    case 'png':
                    case 'gif':
                    case 'bmp':
                    case 'ico':
                    case 'svg':
                        previewPane.html('<div>' + iconImg(data.file) + '</div>');
                        previewPane.addClass('iv__preview--image');
                        break;
                    default:
                        previewPane.html('<div>Format Incompatible</div>');
                        previewPane.addClass('iv__preview--msg');
                        break;
                    }
                } else {
                    previewPane.addClass('iv__preview--icon');
                    previewPane.html('<div>' + this.renderIconImage('hd', data.icon, data) + '</div>');
                }
            } else {
                previewPane.addClass('iv__preview--msg');
                previewPane.html('<div>Choisir un élément...</div>');
            }
        }
    }


IconsView.prototype.val = function () {
        return this.selection;
    };


IconsView.prototype.scroll = function () {
        const myself = this;
        if (!this.element.closest('.window__frame').length) {
            $(window).scrollTop(this.scrollLast)
            const windowTop = $(window).scrollTop();
            const elTop = myself.element.offset().top;
            if (windowTop > 0 && windowTop < elTop) {
                // $(window).scrollTop(elTop)
                $.scrollTo(elTop, 200);
                // $("html, body").animate({ scrollTop: elTop }, "slow");
            }
        }
    }


IconsView.prototype.restoreFilter = function () {
        const myself = this;
        $.each(myself.filters, (filterField, filter) => {
            myself.element.find('.filter.' + filterField).filter('input, select, textarea').val(filter.value);
        });

        myself.applyFilter(false);
    }


IconsView.prototype.applyFilter = function (noApply, filters) {
        const myself = this;
        this.filters = {};

        if (!filters) filters = this.element.add(this.element.parent().parent().parent().find('.iv__toolhook'))

        filters.find('.filter').filter('input, select, textarea').each(function () {
            myself.filters[$(this).data('field')] = {
                value: $(this).val(),
                queryNull: $(this).data('queryNull'),
                keepNull: $(this).data('keepNull'),
                like: $(this).data('like'),
            };
        });

        if (noApply !== false) {
            this.renderIconsAreas();

            if (myself.reloadInput) {
                if (myself.events.refreshInput) myself.events.refreshInput(myself.element);
            }
        }
    }


IconsView.prototype.filter = function (icon) {
        const myself = this;
        if (!icon.special) {
            let state = true;
            $.each(myself.filters, (filterField, filter) => {
                const currentVal = icon.data[filterField];
                if (filter.queryNull || filter.value) {
                    if (filter.value === '') filter.value = null;
                    if (currentVal != filter.value && !(filter.keepNull && !currentVal)) {
                        if (!filter.like || currentVal.search(filter.value) == -1) state = false;
                    }
                }
            });
            return state;
        }
        return true;
    }


IconsView.prototype.sort = function (order, type, side) {
        if (order) {
            if (side) {
                if (side.toLowerCase == 'desc') {
                    this.order = order + '-desc';
                } else {
                    this.order = order;
                }
            }
            else {
                if (this.order == order) {
                    this.order = order + '-desc';
                } else {
                    this.order = order;
                }
            }
        }
        this.orderType = type;
        if (order) this.fixedSort[this.templateName] = [order, side];
        if (this.order) {
            order = this.order.split('-');
            this.element.find('th[data-sort]').removeClass('sorted');
            this.element.find('th[data-sort]').removeClass('sorted-desc');
            this.element.find('th[data-sort=' + order[0] + ']').addClass('sorted' + ((order[1] == 'desc') ? '-desc' : ''));

            /*
             this.element.find('.item-container').each(function() {
             $(this).find('> .iv__item, tbody > .iv__item').sort(this.sortFunction).appendTo($(this));
             });
             */
            const currentContainer = this.element.find('.iv__container');
            for (let i = 0; i < currentContainer.length; i++) {
                $(currentContainer[i]).find('> .iv__item, tbody > .iv__item').sort(this.sortFunction).appendTo(currentContainer[i]);
            }

            // this.element.find('.iv__container').find('> .iv__item, tbody > .iv__item').sort(this.sortFunction).appendTo(this.container);
            // .sort(function(a, b) {if (!$(a).data('sticky')) $(a).data('sticky', 0); if (!$(b).data('sticky')) $(b).data('sticky', 0); console.log(parseFloat($(a).data('sticky'))); return parseFloat($(a).data('sticky')) < parseFloat($(b).data('sticky'));})
        }
    };


IconsView.prototype.sortFunction = function (a, b) {
        const myself = $(a).closest('.iconGrid').data('plugin');
        let { orderType } = myself;
        const order = myself.order.split('-');

        a = $(a);
        b = $(b);

        // sticky compare
        let dataA = (a.data('sticky')) ? a.data('sticky') : 0;
        let dataB = (b.data('sticky')) ? b.data('sticky') : 0;
        if (dataA != dataB) {
            let $sticky = sortCompare(dataB, dataA, 'number');
            if ($sticky !== 0) {
                return $sticky;
            }
        } else {
            if (order[1] == 'desc') {
                const c = a;
                a = $(b);
                b = $(c);
            }

            switch (order[0]) {
            case 'name':
            case 'label':
                return sortCompare(a.data('label').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""), b.data('label').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
            default:
                dataA = String(a.data(order[0]));
                if (dataA == 'undefined' && a.data('data') && (a.data('data').data)) dataA = String(a.data('data').data[order[0]])
                if (dataA != 'undefined') dataA = dataA.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                else dataA = '';

                dataB = String(b.data(order[0]));
                if (dataB == 'undefined' && b.data('data') && (b.data('data').data)) dataB = String(b.data('data').data[order[0]])
                if (dataB != 'undefined') dataB = dataB.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                else dataB = '';

                if (dataA > 0 && dataB > 0) orderType = 'number';

                switch (orderType) {
                case 'number':
                case 'int':
                    return sortCompare(dataA, dataB, 'number');
                default:
                    return sortCompare(dataA, dataB);
                }
            }
        }
    };


IconsView.prototype.submitOrder = function () {
        const myself = this;
        if (this.options.features.sortable) {
            const datas = {};
            const items = this.element.find('.iv__item').not('.iv__breadcrumb__item, .iv__item--special-parent');

            // Field mode
            if (this.dataMode == 'field') {
                const newNodes = [];
                const dataClean = [];
                $.each(this.dataNode, function () {
                    if (this.special) newNodes.push(this);
                });

                for (var i = 0; i < items.length; i++) {
                    var item = $(items[i]);
                    const itemData = item.data('data');
                    newNodes.push(itemData);
                    if (itemData && itemData.dataClean) {
                        dataClean.push(itemData.dataClean);
                    }
                }
                this.dataNode = newNodes;
                this.dataClean = dataClean;

                this.save();
            }
            // Normal
            else {
                for (var i = 0; i < items.length; i++) {
                    var item = $(items[i]);
                    const { field } = this.options.features.sortable;
                    if (item.data('id') && !item.data('data').special) {
                        const type = item.data('type');
                        const currentData = { id: item.data('id') };
                        currentData[field] = i;

                        // append
                        if (!datas[type]) datas[type] = [];
                        datas[type].push(currentData);
                    }
                }

                // each types order array
                $.each(datas, (type, data) => {
                    let { request } = myself.options.features.sortable;
                    if (myself.options.api && myself.options.api[type]) request = myself.options.api[type];

                    ajaxForm({
                        url: request,
                        method: 'POST',
                        data,
                    });
                });
            }
        }
    };


IconsView.prototype.submitParent = function (items, newParent, dropProperties) {
        if (!dropProperties) return;

        const myself = this;
        const data = [];
        let field = dropProperties.field;
        let request = dropProperties.request;

        // Resolve target parent information
        const newParentRawData = newParent.data('data');
        let resolvedNewParentId;
        let newParentTypeStr;

        if (newParentRawData && newParentRawData.special === 'parent') {
            // Special 'parent' back button: target container ID is stored directly on element data('id')
            resolvedNewParentId = newParent.data('id') || (newParentRawData.id !== undefined ? newParentRawData.id : (myself.rootId || null));
            const newParentType = newParent.data('type') || newParentRawData.type;
            newParentTypeStr = Array.isArray(newParentType) ? newParentType[0] : (newParentType || myself.rootType || 'character');
        } else {
            // Regular item, breadcrumb, or tab: target is the element itself
            resolvedNewParentId = newParent.data('id');
            const newParentType = newParent.data('type');
            newParentTypeStr = Array.isArray(newParentType) ? newParentType[0] : newParentType;
        }

        const isRootTarget = (resolvedNewParentId === null || resolvedNewParentId === undefined || resolvedNewParentId == myself.rootId || newParentTypeStr === 'character' || newParentTypeStr === myself.rootType || newParentTypeStr === 'root');

        // Collect items and snapshot their DOM references BEFORE any removal
        const itemSnapshots = [];
        $.each(items, (index, item) => {
            item = $(item);
            let type = item.data('type');
            if (typeof type === 'object') type = type[0];

            if (type) {
                let currentData = {};
                if (dropProperties.data) currentData = Object.assign({}, dropProperties.data);

                if (dropProperties.accept && dropProperties.accept[type] instanceof Object) {
                    if (dropProperties.accept[type].field)   field   = dropProperties.accept[type].field;
                    if (dropProperties.accept[type].request) request = dropProperties.accept[type].request;
                    if (dropProperties.accept[type].data) currentData = Object.assign(currentData, dropProperties.accept[type].data);
                }
                else if (item.data('ref') && item.data('ref') == newParent.data('ref')) {
                    type = 'ref';
                    if (dropProperties.accept[type].field)   field   = dropProperties.accept[type].field;
                    if (dropProperties.accept[type].request) request = dropProperties.accept[type].request;
                    if (dropProperties.accept[type].data) currentData = Object.assign(currentData, dropProperties.accept[type].data);
                }

                if (myself.options.api && myself.options.api[type]) { request = myself.options.api[type]; }

                const accepted = dropProperties.accept
                    ? (dropProperties.accept[type] || (Array.isArray(dropProperties.accept) && dropProperties.accept.includes(type)))
                    : false;

                const itemData = item.data('data');
                const parentObj = itemData ? itemData.parent : null;

                // Check if item is ALREADY in target container (no-op drop)
                let isSameContainer = false;
                if (parentObj) {
                    if (isRootTarget) {
                        isSameContainer = (parentObj.id == myself.rootId || parentObj.type === 'root' || parentObj.id === null || parentObj.id === undefined);
                    } else {
                        isSameContainer = (parentObj.id !== undefined && parentObj.id !== null && parentObj.id == resolvedNewParentId);
                    }
                }

                if (accepted && item.data('id') != resolvedNewParentId && !isSameContainer) {
                    currentData.id = item.data('id');
                    currentData[field] = resolvedNewParentId;
                    data.push(Object.assign({}, currentData));

                    const ivItem = item.hasClass('iv__item') ? item : item.closest('.iv__item');
                    itemSnapshots.push({ item, ivItem, itemData });
                }
            }
        });

        if (data.length === 0) return;

        // ── 1. Immediately remove source elements from DOM ──
        $.each(itemSnapshots, (index, snap) => {
            snap.ivItem.remove();
        });

        // ── 2. Update source data model (remove from canonical parent.childs & dataNode) ──
        $.each(itemSnapshots, (index, snap) => {
            const itemData = snap.itemData || snap.item.data('data');
            if (!itemData) return;

            const sourceParentId = itemData.parent ? itemData.parent.id : null;
            const parentObj = sourceParentId ? myself.findItemById(sourceParentId) : (itemData.parent || myself.dataNodeParent);

            if (parentObj && Array.isArray(parentObj.childs)) {
                const idx = parentObj.childs.findIndex(c => c && c.id == itemData.id);
                if (idx !== -1) parentObj.childs.splice(idx, 1);
            }

            if (Array.isArray(myself.dataNode)) {
                const idx = myself.dataNode.findIndex(c => c && c.id == itemData.id);
                if (idx !== -1) myself.dataNode.splice(idx, 1);
            }
        });

        myself.refreshTree();

        // ── 3. Send AJAX ──
        ajaxForm({
            url: request,
            method: 'POST',
            data,
            callback(resData, form) {
                const resDataObj = (resData && resData.meta) ? resData.meta : (resData && resData.data ? resData.data : {});

                // Update each item in the data model using its snapshot merged with resData
                $.each(itemSnapshots, (index, snap) => {
                    const originalItemData = snap.itemData || {};
                    const updatedItem = Object.assign({}, originalItemData, resDataObj);

                    if (!updatedItem.type && originalItemData.type) {
                        updatedItem.type = originalItemData.type;
                    }
                    if (!updatedItem.label && resDataObj.item && resDataObj.item.name) {
                        updatedItem.label = resDataObj.item.name;
                    } else if (!updatedItem.label && originalItemData.label) {
                        updatedItem.label = originalItemData.label;
                    }
                    if (resDataObj.id) {
                        updatedItem.id = resDataObj.id;
                    }

                    if (isRootTarget) {
                        // Target is root: add to myself.data
                        const rootArr = myself.data;
                        if (Array.isArray(rootArr)) {
                            const existingIdx = rootArr.findIndex(c => c && c.id == updatedItem.id);
                            if (existingIdx !== -1) rootArr[existingIdx] = updatedItem;
                            else rootArr.push(updatedItem);
                        }
                        myself.prepareData(myself.data, { childs: myself.data, type: 'root' }, []);
                    } else {
                        // Target is a child container: find canonical object in myself.data
                        const destObj = myself.findItemById(resolvedNewParentId);
                        if (destObj) {
                            if (!Array.isArray(destObj.childs)) destObj.childs = [];
                            const existingIdx = destObj.childs.findIndex(c => c && c.id == updatedItem.id);
                            if (existingIdx !== -1) destObj.childs[existingIdx] = updatedItem;
                            else destObj.childs.push(updatedItem);

                            myself.prepareData(destObj.childs, destObj, destObj.path || []);
                        }
                    }
                });

                // Always reload the current path data and re-render the view
                myself.loadPath(myself.path, true);
                myself.render();
            },
        });
    };





IconsView.prototype.submitChange = function (item, data) {
        if (item) {
            const myself = this;
            let { api } = item;
            data.id = item.id;
            if (!api && myself.options.api) api = myself.options.api[item.type];

            data = [data];
            ajaxForm({
                url: api,
                method: 'POST',
                data: data,
                callback(data, form) {
                    myself.quickLoad(item, data);
                },
            });
        }
    };


IconsView.prototype.submitDelete = function (item) {
        if (item) {
            const myself = this;
            let { api } = item;
            data.id = item.id;
            if (!api && myself.options.api) api = myself.options.api[item.type];

            ajaxForm({
                url: api,
                method: 'DELETE',
                callback(data, form) {
                    item.remove();
                    // myself.quickLoad(item);
                },
            });
        }
    };


IconsView.prototype.remove = function (item) {
        const myself = this;
        const items = item.parent().find('.iv__item').not(item);
        const dataClean = [];
        for (let i = 0; i < items.length; i++) {
            dataClean.push($(items[i]).data('data').dataClean);
        }
        this.dataClean = dataClean;
        this.save();
        this.quickLoad();
        if (this.events.edit) this.events.edit();
    };


IconsView.prototype.add = function (data) {
        const myself = this;
        // remove empty line
        $.each(this.dataNode, (index, data) => {
            if (data && data.special == 'none') {
                myself.dataNode.splice(index, 1);
            }
        });

        this.dataNode.push(clone(data));
        this.dataClean.push(clone(data));
        this.render();
        if (this.events.edit) this.events.edit();
        this.save();
    }


IconsView.prototype.exportData = function () {
        const output = [];
        $.each(this.dataNode, (index, data) => {
            if (data) {
                output.push(data);
            }
        });
        return output;
    }


IconsView.prototype.testPngAlpha = function ($icon) {
        if (this.cachePng[$icon] === false || this.cachePng[$icon] === true) return this.cachePng[$icon];

        const filestream = load_binary_resource($icon);
        const test = filestream.charCodeAt(25) & 0xff;
        this.cachePng[$icon] = false;
        if (test == 6) {
            this.cachePng[$icon] = true;
        }
        return this.cachePng[$icon];
    }


IconsView.prototype.setCursor = function(cursor) {
        if (cursor != this.cursor && cursor != this.cursorLast && cursor != 'last') {
            this.cursorLast = this.cursor;
        }

        $('body').removeClass(function(index, className) {
            return (className.match(/(^|\s)cursor--\S+/g) || []).join(' ');
        });
        if (cursor == 'last') {
            cursor = this.cursorLast
        }
        if (cursor) {
            $('body').addClass('cursor--' + cursor);
        }
        this.cursor = cursor;
    }


    // the semi-colon before the function invocation is a safety
    // net against concatenated scripts and/or other plugins
    // that are not closed properly.


}
